<label [for]="labelName" class="soft-radio">
  @if (labelPosition() === 'before') {
    <ng-content></ng-content>
  }
  <span
    class="soft-radio-box"
    [class.checked]="checked()"
    [class.disabled]="input.disabled"
    [class.focus]="hasFocus.hasFocus"
  ></span>
  @if (checked()) {
    <span class="soft-radio-bullet"></span>
  }
  <input
    [id]="labelName"
    type="radio"
    class="soft-radio-input"
    [checked]="checked()"
    (change)="setChecked()"
    [disabled]="radioGroup?.readonly() || disabled()"
    softHasFocus
    #hasFocus="softHasFocus"
    #input
    />
  @if (labelPosition() === 'after') {
    <ng-content></ng-content
      >
    }
  </label>
